import script from "./VitaCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./VitaCheckbox.vue?vue&type=style&index=0&id=00e57f8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e57f8d"]])

export default __exports__